import { useCallback, useEffect, useState } from 'react';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CreateIcon from '@mui/icons-material/Create';
import { useStyles } from '../users.style';
import { GetUsers, DeleteUser } from "../../../DAL/users/users";
import { enqueueSnackbar } from "notistack";

export const useUsers = () => {
  const classes = useStyles();
  const [userData, setuserData] = useState([]);
  const [userCount, setuserCount] = useState(0);
  const [singleUser, setSingleUser] = useState('');
  const [open, setOpen] = useState(false);
  const [orderModal, setOrderModal] = useState(false);
  const [action, setAction] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("name")
  const tableCells = [
    { id: 'name', title: 'Name' },
    { id: 'email', title: 'Email' },
    { id: 'password', title: 'Password', type: "password" },
    { id: 'role', title: 'Role', },
    { id: 'actions', title: 'Action(s)' },
  ];
  const actionsIcons = [
    { icon: <DeleteOutlineOutlinedIcon className={classes.iconStyle} /> },
    { icon: <CreateIcon className={classes.iconStyle} /> },
  ];

  useEffect(() => {
    getUsersData(page, limit, search);
  }, [page, limit, search]);

  const getUsersData = useCallback(async(page, limit, search) => {
    setIsLoading(true)
    let data = {
      page: Math.max(page + 1, 1),
      limit: limit,
      key: searchKey,
      value: search
    }
    const response = await GetUsers(data);
        if (response.statusCode == 200) {
          setIsLoading(false);
          setuserData(response?.data?.rows);
          setuserCount(response?.data?.count);
    
        } else {
          setIsLoading(false);
          if (typeof response.message == "string") {
            enqueueSnackbar(response.message, { variant: "error" });
          } else {
            enqueueSnackbar("Invalid credentials", { variant: "error" });
          }
        }
  }, []);

  const handleDelete = useCallback(async(id) => {
    const response = await DeleteUser(id); 
        if (response.statusCode == 200) {
          getUsersData(page, limit, search)
        } else {
          if (typeof response.message == "string") {
            enqueueSnackbar(response.message, { variant: "error" });
          } else {
            enqueueSnackbar("Invalid credentials", { variant: "error" });
          }
        }
  }, []);

  const handleAdd = useCallback(() => {
    setAction('add');
    setOpen(true);
  }, []);

  const handleActionClick = useCallback((index, row) => {
    setSingleUser(row);
    // dispatch(getsingleUserOrderData(row));
    if (index === 0) {
      setAction('delete');
      handleDelete(row.id);
    }
    if (index === 1) {
      setAction('update');
      setOpen(true);
    }
  }, []);

  const handleChangePage = useCallback((isTrue, newPage) => {
    if (isTrue) {
      setPage(newPage - 1);
    } else {
      setPage(newPage);
    }
  }, []);

  const handleChangeRowsPerPage = useCallback(event => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  const calculatePagesCount = (pageSize, totalCount) => {
    return totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
  };

  const handleUserSearch = useCallback(value => {
    setSearch(value);
    setPage(0);
    setLimit(10);
  }, []);

  const handleDropDown = useCallback(value => {
    setSearchKey(value);
    if(search) {
    getUsersData(0, 10, search);
    }
  }, []);
  
  const handleGetUsers = useCallback(value => {
    getUsersData(page, limit, search)
  }, []);

  

  return {
    userData,
    userCount,
    singleUser,
    open,
    orderModal,
    action,
    tableCells,
    actionsIcons,
    page,
    limit,
    isLoading,
    searchKey,
    setOpen,
    setOrderModal,
    handleGetUsers,
    handleAdd,
    handleActionClick,
    handleChangePage,
    calculatePagesCount,
    handleChangeRowsPerPage,
    handleUserSearch,
    handleDropDown,
  };
};
